"use client";

import Image from "next/image";
import Link from "next/link";
import {
  Button,
  Card,
  Center,
  Container,
  Stack,
  Text,
  Title,
} from "@mantine/core";

export default function Home() {
  return (
    <Center style={{ minHeight: "100vh" }}>
      <Container size="xs">
        <Card withBorder padding="xl" radius="lg">
          <Stack gap="lg" align="center">
            <Image
              src="/logo.jpeg"
              alt="Logo Flute Send"
              height={120}
              width={240}
              priority
              style={{ borderRadius: "24px" }}
            />
            <Stack gap={4} align="center" w="100%">
              <Title order={2}>Flute Send</Title>
              <Text c="dimmed" ta="center">
                Gestion des transferts d&apos;argent, vente de crédits, envoi de SMS
              </Text>
            </Stack>
            <Button
              component={Link}
              href="/login"
              size="md"
              fullWidth
            >
              Se connecter
            </Button>
          </Stack>
        </Card>
      </Container>
    </Center>
  );
}
